module.exports = __webpack_public_path__ + "img/horizontal_4_1_pp1_3009.68a49033.png";